// Botón de acción que vive DENTRO de una frase o de un bloque apretado: el `Button` del kit trae
// alto y padding propios y ahí rompe el renglón. Mismo estado de espera: spinner y sin doble clic.
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/cn';

export interface InlineActionButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    /** Muestra el spinner y bloquea el botón mientras la acción está en vuelo. */
    isLoading?: boolean;
    children: ReactNode;
}

export function InlineActionButton({
    isLoading = false,
    disabled = false,
    className,
    children,
    ...props
}: InlineActionButtonProps) {
    return (
        <button
            type="button"
            disabled={disabled || isLoading}
            aria-busy={isLoading}
            className={cn('disabled:cursor-not-allowed disabled:opacity-60', className)}
            {...props}
        >
            {children}
            {isLoading && (
                <Loader2 className="ml-1 inline size-3 animate-spin align-[-1px]" aria-hidden />
            )}
        </button>
    );
}
